/*
 * SLIDING MENU JAVASCRIPT (Clean Restart)
 */
document.addEventListener('DOMContentLoaded', () => {
  const navDrawer = document.getElementById('NavDrawer');
  if (!navDrawer) return;

  const panelsContainer = navDrawer.querySelector('.mobile-nav-panels');
  const drawerTitle = navDrawer.querySelector('.drawer__title');
  const closeButtons = navDrawer.querySelectorAll('.js-drawer-close');

  if (!panelsContainer || !drawerTitle || closeButtons.length < 1) {
    console.error('Sliding menu: Missing required elements.');
    return;
  }

  // --- Main click handler for sliding ---
  panelsContainer.addEventListener('click', (e) => {
    // We only care about clicks on our specific triggers
    const trigger = e.target.closest('.menu-forward-link, .menu-back-button');
    if (!trigger) return;

    e.preventDefault();

    const targetId = trigger.dataset.target;
    const targetPanel = document.getElementById(targetId);
    const currentPanel = trigger.closest('.menu-panel');

    if (!targetPanel || !currentPanel) return;

    if (trigger.classList.contains('menu-forward-link')) {
      // --- GOING FORWARD (Overlay) ---
      targetPanel.classList.add('is-visible');
      // Update drawer title
      if (targetPanel.dataset.panelTitle) {
        drawerTitle.textContent = targetPanel.dataset.panelTitle;
      }
      // Reset scroll position of new panel
      const scroller = targetPanel.querySelector('.menu-panel-scroller');
      if (scroller) scroller.scrollTop = 0;
      
    } else if (trigger.classList.contains('menu-back-button')) {
      // --- GOING BACK (Overlay) ---
      currentPanel.style.transform = 'translate(-100%)';
      setTimeout(()=> {
        
        currentPanel.classList.remove('is-visible');
        currentPanel.removeAttribute('style');
      }, 500);
      
      
      // Update drawer title to the panel we are returning to
      if (targetPanel.dataset.panelTitle) {
        drawerTitle.textContent = targetPanel.dataset.panelTitle;
      }
    }
  });

  // --- Reset all panels when the main drawer 'X' is clicked ---
  closeButtons.forEach(closeButton => {
    closeButton.addEventListener('click', () => {
    // Use a small timeout to let the drawer close animation start
    setTimeout(() => {
      const allPanels = panelsContainer.querySelectorAll('.menu-panel');
      const level1Panel = document.getElementById('panel-level-1');

      // Remove 'is-visible' from all panels EXCEPT Panel 1
      allPanels.forEach(panel => {
        if(panel.id !== 'panel-level-1') {
          panel.classList.remove('is-visible');
        }
      });

      // Reset title to 'Main Menu'
      if (level1Panel && level1Panel.dataset.panelTitle) {
        drawerTitle.textContent = level1Panel.dataset.panelTitle;
      }
    }, 100); // 100ms delay is enough
  });
  });
  
});